import Instance from '../../../Axios';

const AssociarMenuCategoria = (ydata, id) => async (dispatch) => {
  console.log(id, ydata);

  await Instance()
    .post(`/backend/menus/${id}/categorias`, { ydata })
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'POST_MENU_CATEGORIAS', payload: data });
      //   show('success', 'Foram associados novos funcionários á obra');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
        console.log(err);
      }
    });
};

export default AssociarMenuCategoria;
